import { to_rgb } from '../util/colour';

class Dataset {
	constructor(options) {
		this.options = options;
	}
		
	setUnit(unit) {
		this.options.unit = unit;
	}
	
	setColour(colour) {
		let hex = to_rgb(colour, true);
	
		this.options.borderColor = hex;
		this.options.backgroundColor =  hex;	
	}
}

export {
	Dataset
}
